import { screenType } from '@/services/authConstantsV1'
import { customComparator } from '@/services/calculate'
import ActionRenderer from '@/components/DynamicComponents/Admin/MasterData/GridRenderer/actionRendere'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import CommentsRenderer from '@/components/DynamicComponents/Renderers/commentsRenderer'
import CostPriceRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ListRenderer from '@/components/DynamicComponents/Renderers/listRenderer'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import KeywordRenderer from '@/components/DynamicComponents/Renderers/keywordRenderer'
import TagsRenderer from '@/components/DynamicComponents/Renderers/tagRenderer'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export const gridProperties = {
  master: {
    gridOptions: {
      alwaysShowVerticalScroll: true,
      debounceVerticalScrollbar: true,
      alwaysShowHorizontalScroll: true,
      headerHeight: 30,
      rowHeight: 28,
      suppressRowClickSelection: true,
      singleClickEdit: true,
      stopEditingWhenGridLosesFocus: true,
      tooltipShowDelay: 0,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        suppressMovable: true,
        comparator: customComparator,
        resizable: true,
        menuTabs: ['filterMenuTab'],
        filterParams: {
          buttons: ['apply'],
          newRowsAction: 'keep',
        },
      },
    },
    frameworks: {
      actionCellRenderer: ActionRenderer,
      checkboxCellRender: CheckboxRender,
      commentsCellRenderer: CommentsRenderer,
      costPriceCellRenderer: CostPriceRenderer,
      customFilter: CustomFilter,
      keywordRenderer: KeywordRenderer,
      listRenderer: ListRenderer,
      numberRender: NumberRender,
      tagsRenderer: TagsRenderer,
      toolTipRenderer: ToolTipRenderer,
    },
    columns: {
      analysisType: [
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Analysis Type',
          field: 'analysisType',
          width: 400,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Analysis Type',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 100,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.analysisType,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Analysis Type',
            edit: true,
            delete: false,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      assetClass: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 100,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          sort: 'asc',
          headerTooltip: 'Asset Class',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'description',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          width: 250,
          headerTooltip: 'Description',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Default',
          field: 'defaultField',
          width: 75,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          suppressSizeToFit: true,
          headerTooltip: 'Default',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'GDS',
          marryChildren: true,
          children: [
            {
              field: 'gdsLife',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic', searchType: 'number' },
              headerName: 'Life',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Life',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'gdsMethod',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Method',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Method',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'gdsConvention',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Convention',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Convention',
              cellRenderer: 'toolTipRenderer',
            },
          ],
          width: 300,
        },
        {
          headerName: 'ADS',
          marryChildren: true,
          children: [
            {
              field: 'adsLife',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic', searchType: 'number' },
              headerName: 'Life',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Life',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'adsMethod',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Method',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Method',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'adsConvention',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Convention',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Convention',
              cellRenderer: 'toolTipRenderer',
            },
          ],
          width: 300,
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 50,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.assetClass,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Asset Class',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
      bsuop: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          menuTabs: [],
          headerTooltip: 'ID',
          floatingFilter: false,
        },
        {
          headerName: 'BSUOP',
          field: 'bsuop',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          menuTabs: [],
          headerTooltip: 'BSUOP',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 400,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRendererParams: { filter: 'dynamic' },
          comparator: customComparator,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Sequence Number',
          field: 'sequenceNumber',
          width: 60,
          sort: 'asc',
          headerTooltip: 'Sequence Number',
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
          cellRendererParams: { type: 'masterData' },
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 100,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.bsuop,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'BSUOP',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
      buildingUse: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          sortable: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Building Use',
          field: 'buildingUse',
          width: 400,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Building Use',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 100,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.buildingUse,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Building Use',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      categoryCode: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Contract #',
          field: 'contract',
          width: 75,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          headerTooltip: 'Contract #',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Contract',
          field: 'contractName',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Contract',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Category Code',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Asset Class',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'BSUOP',
          field: 'bsuop',
          width: 75,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          filter: 'customFilter',
          headerTooltip: 'BSUOP',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'BSUOP Description',
          field: 'bsuopDescription',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          headerTooltip: 'BSUOP Description',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: '179 Eligible',
          field: 'eligible',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: '179 Eligible',
          cellRenderer: 'tagsRenderer',
          tooltipValueGetter: params => {
            return params.data.eligible ? 'Yes' : 'No'
          },
          menuTabs: [],
        },
        {
          headerName: 'Notes',
          field: 'notes',
          width: 50,
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'commentsCellRenderer',
          headerTooltip: 'Notes',
          cellRendererParams: { title: 'Notes' },
        },
        {
          headerName: 'Keywords',
          field: 'keywords',
          width: 250,
          cellRenderer: 'keywordRenderer',
          sortable: false,
          floatingFilter: false,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          suppressSizeToFit: true,
          headerTooltip: 'Keywords',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 50,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.categoryCode,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Category Code',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
      conditionFactor: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          width: 370,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Condition Factor',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Value',
          field: 'value',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          filter: 'customFilter',
          headerTooltip: 'Value',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 80,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.conditionFactor,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Condition Factor',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      constructionQualityFactor: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Construction Quality Factor',
          field: 'constructionQualityFactor',
          width: 370,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Construction Quality Factor',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Value',
          field: 'value',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          filter: 'customFilter',
          headerTooltip: 'Value',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 80,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.constructionQualityFactor,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Construction Quality Factor',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      contract: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Contract #',
          field: 'contract',
          width: 100,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Contract #',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Contract',
          field: 'contractName',
          width: 370,
          filter: 'customFilter',
          headerTooltip: 'Contract',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic' },
          comparator: customComparator,
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 80,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.contract,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Contract',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
      depreciation: [
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          sort: 'asc',
          headerTooltip: 'ID',
          filter: 'customFilter',
          menuTabs: [],
        },
        {
          headerName: 'Key',
          field: 'key',
          width: 120,
          filter: 'customFilter',
          headerTooltip: 'Key',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Depreciation Type',
          field: 'depreciationType',
          width: 120,
          filter: 'customFilter',
          headerTooltip: 'Depreciation Type',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Title',
          field: 'title',
          width: 80,
          filter: 'customFilter',
          headerTooltip: 'Title',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Table Heading',
          field: 'tableHeading',
          width: 120,
          filter: 'customFilter',
          headerTooltip: 'Table Heading',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Life',
          field: 'life',
          width: 80,
          filter: 'customFilter',
          headerTooltip: 'Life',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Special',
          field: 'special',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Special',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Month PIS',
          field: 'monthPis',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Month PIS',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Label',
          field: 'label',
          width: 120,
          filter: 'customFilter',
          headerTooltip: 'Label',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Year',
          field: 'year',
          width: 80,
          filter: 'customFilter',
          headerTooltip: 'Year',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Value',
          field: 'value',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Value',
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'depreciation %',
          },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Method',
          field: 'method',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Method',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Convention',
          field: 'convention',
          width: 100,
          filter: 'customFilter',
          headerTooltip: 'Convention',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Table',
          field: 'table',
          width: 120,
          filter: 'customFilter',
          headerTooltip: 'Table',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
      ],
      groupingBank: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Grouping',
          field: 'label',
          sort: 'asc',
          filter: 'customFilter',
          width: 100,
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Grouping',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Area',
          field: 'area',
          width: 30,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Area',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Perimeter',
          field: 'perimeter',
          width: 30,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Perimeter',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Tenant Banks',
          field: 'tenantBankDetails',
          width: 400,
          headerTooltip: 'Tenant Banks',
          cellRendererParams: {
            name: 'tenantBank',
            filter: 'dynamic',
            type: 'Tenant Banks',
          },
          cellRenderer: 'listRenderer',
          sortable: false,
          floatingFilter: false,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Templates',
          field: 'templateDetails',
          width: 400,
          headerTooltip: 'Templates',
          cellRendererParams: {
            name: 'template',
            filter: 'dynamic',
            type: 'Templates',
          },
          cellRenderer: 'listRenderer',
          sortable: false,
          floatingFilter: false,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 100,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.groupingBank,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Grouping Bank',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      historicalCostIndex: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Year',
          field: 'year',
          width: 100,
          sort: 'desc',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          headerTooltip: 'Year',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Historical Cost Index',
          field: 'costIndex',
          width: 200,
          filter: 'customFilter',
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            fixed: 4,
            isCheck: true,
          },
          cellRenderer: 'numberRender',
          headerTooltip: 'Historical Cost Index',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Historical Cost Index',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      locationFactor: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Zip Code',
          field: 'zipCode',
          width: 200,
          sort: 'asc',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Zip Code',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
        },
        {
          headerName: 'City',
          field: 'city',
          width: 200,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'City',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
        },
        {
          headerName: 'State',
          field: 'state',
          width: 200,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'State',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
        },
        {
          headerName: 'Location Factor',
          field: 'locationFactor',
          width: 100,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          headerTooltip: 'Location Factor',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Location Factor',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      structuralProfile: [
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Structure Profile',
          field: 'structureProfile',
          width: 180,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Structure Profile',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Building Use',
          field: 'buildingUses',
          width: 600,
          sortable: false,
          filter: 'customFilter',
          cellRenderer: 'listRenderer',
          headerTooltip: 'Building Use',
          cellRendererParams: { name: 'structuralProfile', filter: 'dynamic' },
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 70,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.structureProfile,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          sortable: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Structure Profile',
            edit: true,
            delete: false,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      takeoff: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          sort: 'asc',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGroupings',
          width: 300,
          headerTooltip: 'Takeoff Grouping',
          filter: 'customFilter',
          comparator: customComparator,
          cellRendererParams: { name: 'takeoffGrouping', filter: 'dynamic' },
          cellRenderer: 'listRenderer',
          sortable: false,
          floatingFilter: false,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          width: 100,
          headerTooltip: 'Takeoff Description',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Contract',
          field: 'contract',
          width: 75,
          headerTooltip: 'Contract',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          width: 80,
          headerTooltip: 'Category Code',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 80,
          headerTooltip: 'Asset Class',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Source',
          field: 'source',
          width: 80,
          headerTooltip: 'Source',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Unit',
          field: 'unit',
          width: 50,
          headerTooltip: 'Unit',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          width: 80,
          cellRenderer: 'costPriceCellRenderer',
          headerTooltip: 'Unit Cost',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Cost MULT',
          field: 'costMult',
          width: 75,
          headerTooltip: 'Cost MULT',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'NRML Life',
          field: 'nrmlLife',
          width: 75,
          headerTooltip: 'NRML Life',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Original Description',
          field: 'description',
          width: 80,
          headerTooltip: 'Original Description',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Comments',
          field: 'comments',
          width: 75,
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'commentsCellRenderer',
          headerTooltip: 'Comments',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: { title: 'Comments' },
          menuTabs: [],
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 50,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.takeoff,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: {
            type: 'Takeoff',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
      takeoffGrouping: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          menuTabs: [],
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGrouping',
          width: 280,
          sort: 'asc',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Takeoff Grouping',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 70,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.takeoffGrouping,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Takeoff Grouping',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      tenantBank: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Tenant Name',
          field: 'tenantName',
          width: 250,
          sort: 'asc',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Tenant Name',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Tenant SF',
          field: 'tenantSF',
          width: 100,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            fixed: 0,
          },
          headerTooltip: 'Tenant SF',
          cellRenderer: 'numberRender',
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 250,
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Tenant Type',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Templates',
          field: 'templateDetails',
          width: 400,
          headerTooltip: 'Templates',
          cellRendererParams: {
            name: 'template',
            filter: 'dynamic',
            type: 'Templates',
          },
          cellRenderer: 'listRenderer',
          sortable: false,
          floatingFilter: false,
          suppressSizeToFit: true,
          filter: 'customFilter',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 100,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.tenantBank,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Tenant Bank',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      tenantType: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          sortable: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 400,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Tenant Type',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Tenant Type',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
      unit: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Unit',
          field: 'unit',
          width: 100,
          suppressSizeToFit: true,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Unit',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 370,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRendererParams: { filter: 'dynamic' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Status',
          field: 'isActive',
          width: 80,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'masterData',
            masterType: screenType.unit,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Status',
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Unit',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          hide: false,
          menuTabs: [],
        },
      ],
    },
  },
  import: {
    gridOptions: {
      alwaysShowVerticalScroll: true,
      alwaysShowHorizontalScroll: true,
      headerHeight: 30,
      rowHeight: 28,
      suppressRowClickSelection: true,
      singleClickEdit: true,
      stopEditingWhenGridLosesFocus: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: false,
        suppressMovable: true,
        menuTabs: [],
      },
    },
    columns: {
      assetClass: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Asset Class',
          field: 'AssetClass',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Description',
          field: 'Description',
          tooltipField: 'Description',
          width: 250,
        },
      ],
      categoryCode: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Category Code',
          field: 'CategoryCode',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Description',
          field: 'Description',
          tooltipField: 'Description',
          width: 250,
        },
      ],
      contract: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Contract #',
          field: 'Contract',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Contract',
          field: 'ContractName',
          tooltipField: 'ContractName',
          width: 250,
        },
      ],
      historicalCostIndex: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Year',
          field: 'Year',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Historical Cost Index',
          field: 'CostIndex',
          tooltipField: 'CostIndex',
          width: 250,
        },
      ],
      locationFactor: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Zip Code',
          field: 'ZipCode',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'City',
          field: 'City',
          tooltipField: 'City',
          width: 250,
        },
        {
          headerName: 'State',
          field: 'State',
          tooltipField: 'State',
          width: 250,
        },
        {
          headerName: 'Location Factor',
          field: 'LocationFactor',
          tooltipField: 'LocationFactor',
          width: 250,
        },
      ],
      takeoff: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Takeoff',
          field: 'Takeoff',
          tooltipField: 'Takeoff',
          width: 200,
        },
      ],
    },
  },
}
